

import { useEffect } from 'react'
import { TopNavigation } from './TopNavigation'
import { Sidebar } from './Sidebar'
import { workspaceMenu } from '@/config/dashboard-menu'
import { useSidebar } from '@/hooks/useSidebar'

interface DashboardLayoutProps {
  children: React.ReactNode
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const { isOpen, close } = useSidebar()

  // Close sidebar on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        close()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isOpen, close])

  return (
    <div className="flex h-screen flex-col">
      {/* Top Navigation */}
      <TopNavigation />

      {/* Main Content Area with Sidebar */}
      <div className="flex flex-1 overflow-hidden relative">
        {/* Mobile Backdrop - only visible on mobile when sidebar is open */}
        {isOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={close}
            aria-label="Close sidebar"
          />
        )}

        {/* Sidebar - positioned fixed on mobile, relative on desktop */}
        <div className="fixed md:relative h-full z-50 md:z-auto">
          <Sidebar workspaceMenu={workspaceMenu} />
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-[#00000f]">
          <div className="w-full p-6">{children}</div>
        </main>
      </div>
    </div>
  )
}
